import Vue from 'vue';
import Vuex from 'vuex';

import Device from '@d-shared/utils/device';
import plugins from './plugins';

import '@dui/sass/blog.scss';
import '../styles/blog-public-app.scss';

import components from './components';
import duiComponents from './components/dui.js';
import duiCapitalize from '@dui/filters/dui-capitalize/dui-capitalize';
import duiUsername from '@dui/filters/dui-username/dui-username';
import storeModules from './store';

export default function() {
  if (Device.isiOS()) {
    document.body.classList.add('ios-device');
  }

  Vue.use(Vuex);

  Object.keys(duiComponents).forEach((componentName) => {
    Vue.component(componentName, duiComponents[componentName]);
  });

  Vue.filter('duiCapitalize', duiCapitalize);
  Vue.filter('duiUsername', duiUsername);

  plugins.forEach((plugin) => {
    Vue.use(plugin);
  });

  const store = new Vuex.Store({
    modules: storeModules,
  });

  const app = new Vue({
    el: '#discovery-app',
    store,
    components,
  });
};
